import React, { useEffect, useState, useCallback } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { getAuth, clearAuth } from "./demoConfig";
import useLiveLeads from "./hooks/useLiveLeads";
import DemoTopbar from "./DemoTopbar";
import "./demo.css";
import "./topbar.css";

const SHELL_HIDDEN = ["/demo", "/demo/"]; // login screen

export default function DemoLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!auth && !SHELL_HIDDEN.includes(location.pathname)) {
      navigate("/demo");
    }
  }, [auth, location.pathname, navigate]);

  // Live data — single source of truth
  const live = useLiveLeads({ pollMs: 30000, enabled: !!auth });

  // Compute unread count for the topbar inbox badge
  useEffect(() => {
    if (!live.leads) return;
    const scoped = auth?.username === "admin"
      ? live.leads
      : live.leads.filter(l => l.closerUsername === auth?.username);
    const total = scoped.reduce((s, l) => s + (l.waUnreadCount || 0), 0);
    setUnreadCount(total);
  }, [live.leads, auth]);

  const handleSignOut = useCallback(() => {
    clearAuth();
    navigate("/demo");
  }, [navigate]);

  if (!auth && !SHELL_HIDDEN.includes(location.pathname)) return null;
  if (location.pathname === "/demo" || location.pathname === "/demo/") return <Outlet />;

  // Live demo runner has its own fullscreen UI
  const isLiveDemo = location.pathname.startsWith("/demo/live/") || location.pathname.startsWith("/demo/live2/");

  return (
    <div className="demo-app" data-testid="demo-app">
      {!isLiveDemo && (
        <DemoTopbar
          auth={auth}
          handleSignOut={handleSignOut}
          lastSyncedAt={live.lastSyncedAt}
          onRefresh={live.refresh}
          error={live.error}
          unreadCount={unreadCount}
        />
      )}
      <Outlet context={{ auth, handleSignOut, live }} />
    </div>
  );
}
